import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import ChangePasswordPage from '@/settings/pages/change-password';

export const Route = createFileRoute('/settings/user-profile/change-password')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: ChangePasswordRoute,
  staticData: {
    headerSection: null
  }
});

function ChangePasswordRoute() {
  return <ChangePasswordPage/>;
}
